<template>

    <div class="dropdown filter">
        <button class="btn btn-lg btn-outline-secondary dropdown-toggle text-truncate text-start w-100 filter__btn" type="button" :title="translatedLabel"
                :id="id" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
            {{ translatedLabel }}
        </button>
        <div class="dropdown-menu w-100 p-0" :aria-labelledby="id">
            <slot />
        </div>
    </div>

</template>

<script>
    export default {
        props: {
            id: {
                type: String,
                default() {
                    return `filter-${this._uid}`
                },
            },
            label: String,
        },
        components: {
        },
        data() {
            return {}
        },
        methods: {
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
    }
</script>
